import React, { useEffect, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionProps {
  title: string;
  content?: string;
  emoji?: string;
  image?: string;
}
export function Accordion({
  title,
  content,
  emoji,
  image
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-white/20 rounded-lg mb-3 bg-black/40 backdrop-blur-sm overflow-hidden" data-id="element-52">
      {image && <div className="relative h-32 w-full overflow-hidden" data-id="element-53">
          <img src={image} alt={title} className="w-full h-full object-cover object-top" data-id="element-54" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" data-id="element-55" />
        </div>}
      <button className="w-full px-4 py-3 flex items-center justify-between text-left text-white font-medium focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-56">
        <div className="flex items-center gap-3" data-id="element-57">
          {emoji && <span className="text-xl" data-id="element-58">{emoji}</span>}
          <span className="text-sm sm:text-base" data-id="element-59">{title}</span>
        </div>
        {isOpen ? <ChevronUp className="w-5 h-5 text-tennis-yellow flex-shrink-0" data-id="element-60" /> : <ChevronDown className="w-5 h-5 text-tennis-yellow flex-shrink-0" data-id="element-61" />}
      </button>
      {isOpen && content && <div className="px-4 py-3 text-white/80 text-sm border-t border-white/10 bg-black/20" data-id="element-62">
          {content}
        </div>}
    </div>;
}